/*
* Engagebay CRM form
*/

import * as Cookie from './modules/cookie.js';
import * as Referrer from './modules/referrer.js';
import * as Form from './modules/form.js';

const TEST_MODE  = false;
const cookie_name = 'r';
const max_age_agent = (!TEST_MODE) ? 60 : ((1 / 86400) * 60)  * 6;
const max_age_partner = (!TEST_MODE) ? 365 : ((1 / 86400) * 60) * 10;
const currentUrl = new URL(window.location.href);
// const domain_name = 'https://testagent.2futures.com/';
const pluginPath = 'wp-content/plugins/crm-form';
const domain_name = `https://${currentUrl.hostname}/${pluginPath}/bridge.php`;
const uri_referrer_get = `${domain_name}?action=referrer&code=`;
const uri_form_get = `${domain_name}?action=form&name=`;
const uri_form_submit = `${domain_name}?action=submit&name=`;
const referrer_type_partner = 'Partner';
const formSelector = '.crm-engagebay-form';

window.addEventListener('DOMContentLoaded', event => {
    console.debug('engagebay-crm-form.js loaded!');
    startManagement({ selector: formSelector });
    console.log(domain_name);
});

const startManagement = ({ selector }) => {
    const UrlParameters = new URLSearchParams(window.location.search);
    if(UrlParameters.has(cookie_name)) {
        console.debug('Parameter "%s" found', cookie_name);
        const code = UrlParameters.get(cookie_name);
        console.debug('%s value = %s', cookie_name, code);
        Referrer.referrerGet({
            code: code,
            uri: uri_referrer_get,
            success: response => {
                successReferrerGet(response);
                Form.loadForms({
                    selector: selector,
                    getFormUrl: uri_form_get,
                    endCallback: () => {
                        updateAllForm();
                        loadCookieInfo();
                    }
                });
            },
            fail: failReferrerGet
        });
    } else {
        Form.loadForms({
            selector: selector,
            getFormUrl: uri_form_get,
            // callback: updateForm,
            endCallback: () => {
                updateAllForm();
                loadCookieInfo();
            },
            submit_url: uri_form_submit
        });
    }
};

const displayError = ({status, message}) => {
    console.error({ status, message });
};

const successReferrerGet = request => {
    console.debug(request);
    if(!request.data.response) {
        console.error('No Response');
        return;
    }
    const response = request.data.response;
    if(!response) {
        displayError({ status: 0, message: "Response is empty!"});
        return;
    }
    if(!response.done) {
        displayError({ status: 1, message: (response.message ? response.message : "Action not done!")});
        return;
    }
    if(!isReferrerValid(response.referrer)) return;
    const maxAge = response.is_partner ? max_age_partner : max_age_agent;
    Cookie.cookieSet(cookie_name, response.code, maxAge);
    Referrer.hydrate(response.referrer, maxAge);
};

const failReferrerGet = xhr => {
    displayError({
        status: xhr.status,
        message: xhr.statusText
    });
    return;
};

const isReferrerValid = referrer => {
    return ( referrer
        && referrer.code != undefined
        && referrer.fullname != undefined
        && referrer.email != undefined
        && referrer.type != undefined
        );
};

const updateAllForm = () => {
    const forms = document.querySelectorAll('.crm_engagebay_form');
    if(!forms || !forms.length) return;
    forms.forEach(form => {
        updateForm(form);
    });
}

const updateForm = (form) => {
    console.debug('!!! Update Form !!!');
    console.debug(form);
    const referrer = Referrer.get();
    console.debug(referrer);
    if(!referrer.code && !referrer.email && !referrer.name && !referrer.type) {
        console.debug('No referrer information');
        return;
    }
    if(referrer.code) {
        console.debug('Adding Referrer Code "%s"', referrer.code);
        Form.buildInput({
            form: form,
            input: {
                id: 'referrer_code',
                name: 'referrer_code',
                value: referrer.code,
                type: 'hidden',
                tagName: 'input'
            }
        });
    }
    if(referrer.email) {
        console.debug('Adding Referrer Email "%s"', referrer.email);
        Form.buildInput({
            form: form,
            input: {
                id: 'referrer_email',
                name: 'referrer_email',
                value: referrer.email,
                type: 'hidden',
                tagName: 'input'
            }
        });
    }
    if(referrer.name) {
        console.debug('Adding Referrer Name "%s"', referrer.name);
        Form.buildInput({
            form: form,
            input: {
                id: 'referrer_name',
                name: 'referrer_name',
                value: referrer.name,
                type: 'hidden',
                tagName: 'input'
            }
        });
    }
    if(referrer.type) {
        console.debug('Adding Referrer Type "%s"', referrer.type);
        Form.buildInput({
            form: form,
            input: {
                id: 'referrer_type',
                name: 'referrer_type',
                value: referrer.type,
                type: 'hidden',
                tagName: 'input'
            }
        });
    }
};

const loadCookieInfo = () => {
    console.debug('Load Cookie Info');
    const r = Cookie.cookieGet('r');
    const cookies = document.querySelector('#cookies');
    while(cookies.firstChild) {
        cookies.removeChild(cookies.firstChild);
    }
    if(!r) {
        codeSet({container: cookies, content: 'N/A'});
        return false;
    }
    codeSet({container: cookies, content: r});
    nameSet({ container: cookies, content: Cookie.cookieGet('referrer_name') });
    emailSet({ container: cookies, content: Cookie.cookieGet('referrer_email') });
    typeSet({ container: cookies, content: Cookie.cookieGet('referrer_type') });
    expirationSet({ container: cookies, content: Cookie.cookieGet('cookie_expiration') });
};

const codeSet = ({container, content}) => {
    const row = document.createElement('div');
    row.classList.add('row', 'my-3');
    const label = document.createElement('div');
    label.classList.add('col-12', 'col-sm-6', 'col-md-5');
    label.innerHTML = 'Referrer Code';
    const widget = document.createElement('div');
    widget.classList.add('col-12', 'col-sm-6', 'col-md-7');
    widget.innerHTML = `<strong>${content != undefined ? content : 'N/A'}</strong>`;
    row.append(label);
    row.append(widget);
    container.append(row);
};

const nameSet = ({ container, content }) => {
    const row = document.createElement('div');
    row.classList.add('row', 'my-3');
    const label = document.createElement('div');
    label.classList.add('col-12', 'col-sm-6', 'col-md-5');
    label.innerHTML = 'Referrer Name';
    const widget = document.createElement('div');
    widget.classList.add('col-12', 'col-sm-6', 'col-md-7');
    widget.innerHTML = `<strong>${content != undefined ? content : 'N/A'}</strong>`;
    row.append(label);
    row.append(widget);
    container.append(row);
};

const emailSet = ({ container, content }) => {
    const row = document.createElement('div');
    row.classList.add('row', 'my-3');
    const label = document.createElement('div');
    label.classList.add('col-12', 'col-sm-6', 'col-md-5');
    label.innerHTML = 'Referrer Email';
    const widget = document.createElement('div');
    widget.classList.add('col-12', 'col-sm-6', 'col-md-7');
    widget.innerHTML = `<strong>${content != undefined ? content : 'N/A'}</strong>`;
    row.append(label);
    row.append(widget);
    container.append(row);
};

const typeSet = ({ container, content }) => {
    const row = document.createElement('div');
    row.classList.add('row', 'my-3');
    const label = document.createElement('div');
    label.classList.add('col-12', 'col-sm-6', 'col-md-5');
    label.innerHTML = 'Referrer Type';
    const widget = document.createElement('div');
    widget.classList.add('col-12', 'col-sm-6', 'col-md-7');
    widget.innerHTML = `<strong>${content != undefined ? content : 'N/A'}</strong>`;
    row.append(label);
    row.append(widget);
    container.append(row);
};

const expirationSet = ({ container, content }) => {
    if(typeof(content) == "string") {
        content = parseInt(content);
    }
    content = isNaN(content) ? 0 : content;
    const now = new Date();
    let diff = Math.trunc((content - now.getTime()) / 1000);
    let time = formatTime(diff);
    const row = document.createElement('div');
    row.classList.add('row', 'my-3');
    const label = document.createElement('div');
    label.classList.add('col-12', 'col-sm-6', 'col-md-5');
    label.innerHTML = 'Expires in';
    const widget = document.createElement('div');
    widget.classList.add('col-12', 'col-sm-6', 'col-md-7');
    widget.innerHTML = `<strong>${time}</strong>`;
    row.append(label);
    row.append(widget);
    container.append(row);
    const updateExpiration = setInterval(() => {
        diff--;
        if(diff < 0) {
            clearInterval(updateExpiration);
            removeReferrerInfoEverywhere();
            return;
        }
        time = formatTime(diff);
        const classes = diff < 60 ? 'text-danger' : '';
        widget.innerHTML = `<strong class="${classes}">${time}</strong>`;
    }, 1000);
};

const formatTime = (seconds) => {
    let days = 0;
    let hours = Math.trunc(seconds / 3600);
    let minutes = Math.trunc((seconds - (hours * 3600)) / 60);
    seconds = seconds - (hours * 3600) - (minutes * 60);
    if(hours > 23) {
        days = Math.trunc(hours / 24);
        hours = hours - (days * 24);
    }
    let formattedTime = '';
    if(days > 0) formattedTime += `${days} day(s) `;
    if(hours > 0) formattedTime += `${hours} hour(s) `;
    if(minutes > 0) formattedTime += `${minutes} minute(s) `;
    if(seconds > 0) formattedTime += `${seconds} second(s)`;
    return formattedTime;
};

const removeReferrerInfoEverywhere = () => {
    console.debug('Remove all referrer information everywhere');
    const allForms = document.querySelectorAll('.crm-engagebay-form');
    if(!allForms || allForms.length == 0) return;
    const cookies = document.querySelector('#cookies');
    while(cookies.firstChild) cookies.removeChild(cookies.firstChild);
    codeSet({container: cookies, content: 'N/A'});
    nameSet({ container: cookies, content: 'N/A' });
    emailSet({ container: cookies, content: 'N/A' });
    typeSet({ container: cookies, content: 'N/A' });
    const row = document.createElement('div');
    row.classList.add('row', 'my-3');
    const label = document.createElement('div');
    label.classList.add('col-12', 'col-sm-6', 'col-md-5');
    label.innerHTML = 'Expires in';
    const widget = document.createElement('div');
    widget.classList.add('col-12', 'col-sm-6', 'col-md-7');
    widget.innerHTML = `<strong class="text-danger">Expired</strong>`;
    row.append(label);
    row.append(widget);
    cookies.append(row);

    allForms.forEach(form => {
        const code = form.querySelector('#referrer_code');
        console.debug(code);
        if(code) code.remove();

        const name = form.querySelector('#referrer_name');
        console.debug(name);
        if(name) name.remove();

        const email = form.querySelector('#referrer_email');
        console.debug(email);
        if(email) email.remove();

        const type = form.querySelector('#referrer_type');
        console.debug(type);
        if(type) type.remove();
    });
    Referrer.unset();
};
